import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AI_ADMIN_QUERY_KEYS } from 'app/modules/aiAdmin/queries/keys';
import { post } from 'app/shared/utils/fetchr';
import { AutoSetupAIAgentResponse } from 'app/modules/aiAdmin/responses';
import { AutoSetupAIAgentPayload } from 'app/modules/aiAdmin/requests';
import { useDispatch } from 'react-redux';
import { sendErrorToast } from 'app/shared/toasts/actions';

export const useAutoSetupAiAgent = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AutoSetupAIAgentPayload) =>
      post<AutoSetupAIAgentResponse>(
        '/ai-admin-dashboard/agents/auto-setup',
        payload,
      ),
    onError: () =>
      dispatch(sendErrorToast('Failed to configure agent. Please try again.')),
    onSuccess: () => {
      // Invalidate the AI agents query to refetch the latest data
      queryClient.invalidateQueries({
        queryKey: AI_ADMIN_QUERY_KEYS.getAiAgents(),
      });
    },
  });
};
